import type * as Y from "yjs";

export type TextDiff = { index: number; remove: number; insert: string };

/** Smallest single-range diff between two strings — enough to keep Yjs merges sane. */
export function diffText(before: string, after: string): TextDiff | null {
  if (before === after) return null;

  let start = 0;
  const max = Math.min(before.length, after.length);
  while (start < max && before[start] === after[start]) start += 1;

  let end = 0;
  while (
    end < max - start &&
    before[before.length - 1 - end] === after[after.length - 1 - end]
  ) {
    end += 1;
  }

  return {
    index: start,
    remove: before.length - start - end,
    insert: after.slice(start, after.length - end),
  };
}

export function applyTextDiff(text: Y.Text, next: string): void {
  const diff = diffText(text.toString(), next);
  if (!diff) return;
  text.doc?.transact(() => {
    if (diff.remove > 0) text.delete(diff.index, diff.remove);
    if (diff.insert.length > 0) text.insert(diff.index, diff.insert);
  });
}
